<script setup lang="ts">
interface Props {
  label: string
  value?: string
}

defineProps<Props>()
</script>

<template>
  <div v-if="value">
    <div class="text-xs text-gray-700">{{ label }}</div>
    <div class="text-sm">{{ value }}</div>
  </div>
</template>
